<template>
<div class="border card-content-hover shadow shadow-sm">
  <div class="content  p-3">
<img class="w-100 text-center img-content" src="https://picsum.photos/200/300" alt="">
<h3 class="mt-3">حامد</h3>
<p class="mt-3">مسعودی</p>
<div class="mt-4 text-left div">
<m-a class="text-left " href="#"> <m-icon icon="arrow-left"></m-icon><span class="h5">بیشتر </span>  </m-a>
</div>

</div>
</div>
</template>


<script>
export default {
  components: {},
  name: "C802",
};
</script>


<style scoped>
.img-content{
  object-fit: cover;
  height: 300px;
  width: 300px;
}

.card-content-hover:hover {
  padding:  25px 0;
  box-shadow: 3px 5px 52px -5px rgba(0,0,0,0.61) !important;
-webkit-box-shadow: 3px 5px 52px -5px rgba(0,0,0,0.61) !important;
-moz-box-shadow: 3px 5px 52px -5px rgba(0,0,0,0.61) !important;
  }
</style>
